import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { QuizSolutionDialogData } from '../../../data/dialogData/QuizSolutionDialogData';


@Component({
    selector: 'app-quiz-solution-dialog',
    imports: [],
    templateUrl: './quiz-solution-dialog.component.html',
    styleUrl: './quiz-solution-dialog.component.scss'
})
export class QuizSolutionDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<QuizSolutionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: QuizSolutionDialogData
  ) {}

  onPrimaryClick(): void {
    this.dialogRef.close(true);
  }

  onSecondaryClick(): void {
    this.dialogRef.close(false);
  }
}
